import { createContext, useContext } from 'react';

// openAuthModal(mode?) — mode is 'register' | 'login', defaults to 'register'
export const AuthModalContext = createContext({ openAuthModal: () => {} });
export const useAuthModal = () => useContext(AuthModalContext);
